<template>
    <div>
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="1041px"
            @close="setDialogClosed" append-to-body>
            <el-container direction="vertical">
                <el-row>
                    <el-card style="
                margin-top: 0px;
                margin-left: 0px;
                margin-right: 5px;
                margin-bottom: 10px;
                height: 180px;
              ">
                        <el-descriptions size="medium" title="上年度评估结果" :column="3" :colon="false">
                            <template slot="extra">
                                <el-button type="primary" size="mini">生成新年度一体化管理方案</el-button>
                            </template>
                            <el-descriptions-item label="年度血糖控制情况:">
                                <el-tag size="small" type="success" style="margin-left: 10px;">达标</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="最近一次空腹血糖:">6.3（达标）</el-descriptions-item>
                            <el-descriptions-item label="最近一次糖化血红蛋白:">6.2（达标）</el-descriptions-item>
                            <el-descriptions-item label="最近一次血压:">130/80（达标）</el-descriptions-item>
                            <el-descriptions-item label="最近一次血脂:">TC:3.9/TG:1.2</el-descriptions-item>
                            <el-descriptions-item label="危险因素:">无</el-descriptions-item>
                            <el-descriptions-item label="并发症:">无</el-descriptions-item>
                            <el-descriptions-item label="评估人:">单宝华</el-descriptions-item>
                            <el-descriptions-item label="评估时间:">2025-05-01</el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </el-row>

                <el-row>
                    <el-col :span="8">
                        <el-card style="height: 450px;">
                            <div slot="header" class="clearfix">
                                <span>推荐方案</span>
                                <el-tag size="mini" style="margin-left: 10px;">糖尿病患者达标管理</el-tag>
                            </div>
                            <el-table size="small" :data="dataList1" height="300px" border fit highlight-current-row
                                style="width: 100%;">
                                <el-table-column width="45px" label="序号">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.index }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="项目">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.item }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100px" label="频次">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.fre }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>

                    </el-col>

                    <el-col :span="16">
                        <el-card style="margin-left: 10px;height: 450px;">
                            <div slot="header" class="clearfix">
                                <span>方案</span>
                            </div>

                            <el-table size="small" :data="dataList2" height="300px" border fit
                                style="width: 100%;">
                                <el-table-column label="指标">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.item }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="目标">
                                    <template slot-scope="scope">
                                        <el-input size="mini" v-model="scope.row.target" placeholder="请输入内容"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="指标单位">
                                    <template slot-scope="scope">
                                        <el-input size="mini" v-model="scope.row.unit" placeholder="请输入内容"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" align="center" label="操作" width="100">
                                    <template slot-scope="scope">
                                        <el-button style="margin-left: 0px; align-self: center" type="text">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div style="margin-top: 10px; margin-bottom:10px;">
                                <el-link style="float: left;margin-bottom: 10px;" type="primary"
                                    icon="el-icon-edit">增加主要指标</el-link>
                                <div style="float: right; margin-bottom:10px;">
                                    <el-button size="mini" type="primary" @click="onSubmit">确定保存</el-button>
                                    <el-button size="mini">取消</el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-container>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    components: {},
    data() {
        return {
            showDialog: false,
            title: "一体化管理方案导入",
            dataContext: null,
            dataList1: [
                {
                    index: 1,
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    index: 1,
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    index: 1,
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    index: 1,
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    index: 1,
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    index: 1,
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                }
            ],
            dataList2: [
                {
                    item: '空腹血糖',
                    target: '4.6',
                    unit: 'mmol/L'
                },
                {
                    item: '空腹血糖',
                    target: '4.6',
                    unit: 'mmol/L'
                },
                {
                    item: '空腹血糖',
                    target: '4.6',
                    unit: 'mmol/L'
                },
                {
                    item: '空腹血糖',
                    target: '4.6',
                    unit: 'mmol/L'
                }
            ]
        };
    },
    methods: {
        // 编辑初始化页面内容
        async init(dataContext) {
            console.log("一体化方案导入：", dataContext);
            this.dataContext = dataContext;
            this.showDialog = true;
            this.$nextTick(() => {
                this.getDetail();
            });
        },
        // 关闭对话框触发
        setDialogClosed() {
            this.showDialog = false;
        },
        getParsedTime(time) {
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
        getDetail() {

        },
        onSubmit() {

        }
    },
};
</script>

<style scoped>
.custom-class {
    color: white;
}

.cardColorBlue {
    background: linear-gradient(to right, #9fccfc, #618bff);
}

::v-deep .el-table__body tr.current-row>td {

    background: #66b1ff !important;

    color: #ffffff !important;

}
</style>